import React, { PureComponent, ReactNode, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { StaticContext, useHistory } from 'react-router';

import { initVisit } from '../store/actions/visit';
import LeftBar from '../components/common/NavBar';
import { Patient } from '../store/types/patient';
import {
    GO_TO_ADD_NEW_PATIENT,
    GO_TO_ALL_PATIENTS,
    GO_TO_APPOINTMENTS,
    GO_TO_NEW_APPOINTMENT,
    GO_TO_PATIENTS_DETAILS,
    GO_TO_PRESCRIPTION_PAD,
} from '../routes/paths';
import { Helmet } from 'react-helmet';
import {
    getDoc,
    getItemFromMisc,
    MISC_KEYS,
    getSelectedClinicId,
    getVisitByIds,
    getDoctorSelectorList,
    amIDoctorOnly,
    getMyClinics,
    isSingleDoctorAccess,
    getPatientByLocalId,
} from '../store/idbHandler';
import {
    addPatient,
    NewPatient as AddPatientNewPatient,
    WithBEPatient,
} from '../store/actions/app';
import { ThunkDispatch } from 'redux-thunk';
import { GlobalState } from '../store/reducers';
import { Actions } from '../store/actions';
import PatientInfoComp from './PatientInfoComp';
import fetchBookSlotHash, { Res } from '../api/fetchBookSlotHash';
import bookAppointment, { RequestResponse } from '../api/bookAppointment';
import { track } from '../tracking';
import { AnimatePresence } from 'framer-motion';
import { IFrameBareDialog } from '../components/common/IFrameDialog';
import { GenieSettings, SREV2 } from '../api/pushGenie';
import { CURIO_IFRAME_ID } from './MyCalendar';
import { ConfigureDyForms } from '../components/newPatient/ConfigureDyForms';
import { printLabelForPatient } from '../modules/barcode';
import { captureError, captureErrorString } from './captureError';
import { AppointmentsResponse, fetchTodayQueue } from '../api/fetchAppointmentsV2';
import {
    getAppointmentAction,
    getAppointmentActionTextForAction,
    isCNRE,
    onAppointmentAction,
} from './AppointmentUtils';
import { AddAddressBt } from '../components/prescriptionPad/rightPanel/finishScreen/AddAddressBt';
import { APWithOptionalpatient } from './Appointments';
import { EKA_EVENT, dispatch as ekaEventDispath } from '../bridge/events/dispatch';
import { isOnboardedForLab, isOnboardedForPharma, uploadPatientPic } from './utils';
import {
    ADD_NEW_PT_APPT,
    DESTROY_CONTAINER,
    Events,
    ON_CLOSE_ABHA_CREATION_POPUP,
    PATIENT_ABHA_CREATE,
} from '../bridge/events/types';
import { getGenieSetting } from '../store/selectors/session';
import { ConfigTabs } from '../components/prescriptionPad/rightPanel/workspace/padV2/ConfigureElementsTableDialog';
import { MHC } from '../store/types/medicalHistory';
import { IFormState } from '../components/common/types/add-patient';
import { CountryCode, parsePhoneNumber } from 'libphonenumber-js';
import { getMyDbId, getMyIdWithBackwardCompatibility } from '../api/mactiveid';
import DoctorSelectorPopup from '../components/common/DoctorSelectorPopOver';
import { MyDoc } from '../api/fetchMyProfile';
import { getAccessControl, showAccessDeniedError } from '../store/AccessControl';
import SlotModal from '../components/appointment/slot-modal';
import { BookAptModalState } from './AllPatients';
import moment from 'moment';
import { Appointment } from '../api/fetchAppointmentById';
import AdmitPatientAddPtButton from '../components/IPD/AdmitPatientAddPtButton';
import { getAclViewClassName } from '../restrictions/utils';
import { his } from './history';
import { crossIcon } from '../components/common/Icons';
import pushPtMedHistory from '../api/pushPtMedHistory';
import { notification } from 'antd';

type ActionDialogProps = {
    pName: string;
    cId: string;
    isBookSlotLoading?: boolean;
    onStartPrescription: (visitType: string, docid: string) => void;
    onSendReceipt: (docid: string) => void;
    onSlotBook: () => void;
    onAddToQueue: (docid: string) => Promise<RequestResponse | undefined>;
    onPrintLabel: () => void;
    newPatient?: Patient;
    todayAppointments?: APWithOptionalpatient[];
    onStartResumeVisit: (todayAppointment: APWithOptionalpatient, cId: string) => void;
    selectedDocId?: string;
    closeMe?: () => void;
};

export const BookASlot: React.FC<{
    isLoading?: boolean;
    onSlotBook?: () => void;
}> = ({ isLoading, onSlotBook }) => {
    return (
        <div
            className="flex items-center p-12 space-x-8 bg-status-infoBG rounded-8 cursor-pointer border border-transparent hover:border-actionPrimary"
            onClick={onSlotBook}
        >
            <div className="flex items-center justify-center w-40 h-40 bg-white rounded-full">
                {isLoading ? (
                    <svg
                        viewBox="0 0 512 512"
                        className="fill-actionPrimary animate-spin"
                        width="20"
                        height="20"
                    >
                        <path d="M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z" />
                    </svg>
                ) : (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        className="fill-actionPrimary w-20 h-20"
                    >
                        <path d="M336 292v24c0 6.6-5.4 12-12 12h-76v76c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-76h-76c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h76v-76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v76h76c6.6 0 12 5.4 12 12zm112-180v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z" />
                    </svg>
                )}
            </div>
            <p className="text-14 font-700 text-actionPrimary">Book Appointment</p>
        </div>
    );
};

export const SendReceipt: React.FC<{ onSendReceipt?: () => void }> = ({ onSendReceipt }) => {
    const canCreateReceipt = getAccessControl().isAccessAvailable(
        SREV2.CAN_CREATE_RECEIPT_WITH_APT,
    );

    return (
        <div
            className={`flex items-center p-12 space-x-8 bg-status-infoBG rounded-8 cursor-pointer border border-transparent hover:border-actionPrimary ${getAclViewClassName(
                SREV2.CAN_CREATE_RECEIPT_WITH_APT,
            )}`}
            onClick={canCreateReceipt ? onSendReceipt : showAccessDeniedError}
        >
            <div className="flex items-center justify-center w-40 h-40 bg-white rounded-full">
                <svg className="fill-actionPrimary w-20 h-20" viewBox="0 0 384 512">
                    <path d="M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"></path>
                </svg>
            </div>
            <div>
                <p className="text-14 font-700 text-actionPrimary">Bill Patient</p>
                <p className="text-12 text-neutral-1 opacity-60">+ Add to Queue</p>
            </div>
        </div>
    );
};

export const AddToQueue: React.FC<{
    cId: string;
    onAddToQueue?: () => Promise<RequestResponse | undefined>;
}> = ({ onAddToQueue, cId }) => {
    const history = useHistory();

    const [apiState, setApiState] = useState<'' | 'loading' | 'success' | 'error'>();

    const addToQueue = () => {
        setApiState('loading');

        onAddToQueue?.()
            .then((res) => {
                if (res?.success) {
                    // history.replace(GO_TO_APPOINTMENTS(cId));
                    setApiState('success');
                } else {
                    setApiState('error');
                    captureErrorString('Failed to add patient: ' + JSON.stringify(res));
                    track('ERROR', { on: 'onAddToQueue', error: JSON.stringify(res) });
                    alert(res?.error?.type || '[1] Failed to add to queue');
                }
            })
            .catch((e) => {
                setApiState('error');
                alert('[2] Failed to add to queue');
                captureError(e);
                track('ERROR', { on: 'onAddToQueue', error: (e as Error).message });
            });
    };

    return (
        <div
            onClick={addToQueue}
            className="flex flex-col items-center justify-center space-y-24 border border-transparent cursor-pointer rounded-8 w-144 h-144 hover:border-actionPrimary bg-status-infoBG"
        >
            <div className="flex items-center justify-center w-64 h-64 rounded-full bg-white">
                <div className="flex items-center w-20 h-20 justify-center">
                    {apiState === 'loading' ? (
                        <svg
                            viewBox="0 0 512 512"
                            className="w-24 h-24 fill-actionPrimary animate-spin"
                        >
                            <path d="M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z" />
                        </svg>
                    ) : (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 640 512"
                            className="w-24 h-24 fill-actionPrimary"
                        >
                            <path d="M224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm89.6 256c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zm224-248h-72v-72c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v72h-72c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h72v72c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-72h72c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z" />
                        </svg>
                    )}
                </div>
            </div>
            <p className="text-actionPrimary font-700 text-14">Add to Queue</p>
        </div>
    );
};

const ActionDialog: React.FC<ActionDialogProps> = ({
    pName,
    onStartPrescription,
    onSlotBook,
    onSendReceipt,
    onPrintLabel,
    onAddToQueue,
    cId,
    isBookSlotLoading,
    newPatient,
    todayAppointments,
    onStartResumeVisit,
    selectedDocId,
    closeMe,
}) => {
    const history = useHistory();
    const [isAbhaModalVisible, setIsAbhaModalVisible] = useState(false);

    const onGoToAllPatients = () => {
        track('Go_To_All_pt', { from: 'New_pt' });
        history.replace(GO_TO_ALL_PATIENTS(cId));
        closeMe?.();
    };

    const onAddNewPt = () => {
        track('Add_New_pt', { from: 'New_pt' });
        window.history.replaceState({}, document.title, window.location.pathname);
        window.location.href = GO_TO_ADD_NEW_PATIENT(cId);
    };

    const [isBarcodeEnabled, setIsBarcodeEnabled] = useState(false);

    useEffect(() => {
        getItemFromMisc<GenieSettings>(
            getMyIdWithBackwardCompatibility() || '',
            MISC_KEYS.settings,
        ).then((res) => {
            setIsBarcodeEnabled(res.barcodeEnabled);
        });
    }, []);

    const apptIndex = todayAppointments
        ? todayAppointments.findIndex((a) => a.patient_oid === newPatient?.id)
        : -1;

    const selectedDoc = selectedDocId
        ? getDoctorSelectorList().find((t) => t.id === selectedDocId)
        : null;

    return (
        <div className="modal-show">
            <div className="modal-overlay" onClick={closeMe}></div>
            <div className="modal-content min-w-70p">
                <div className="flex items-center justify-between p-16 bg-neutral-9 rounded-t-4">
                    <p className="font-700 text-18">Choose your action</p>
                    {closeMe && (
                        <span onClick={closeMe} className="cursor-pointer">
                            {crossIcon('w-14 h-14')}
                        </span>
                    )}
                </div>
                <div className="w-full border-b border-neutral-7"></div>
                <div className="flex justify-between items-center px-24 py-16 bg-status-successBG">
                    <div className="flex space-x-16">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                            className="fill-status-success w-16 h-16"
                        >
                            <path d="M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z" />
                        </svg>
                        <p className="text-neutral-3 font-700">
                            Details of {pName} have been updated in{' '}
                            {selectedDoc
                                ? [selectedDoc?.personal.name.f, selectedDoc?.personal.name.l, "'s"]
                                      .filter(Boolean)
                                      .join(' ')
                                : 'your'}{' '}
                            patient directory{' '}
                        </p>
                    </div>
                    {isBarcodeEnabled && (
                        <button
                            className="secondary-btn px-8 py-4 body-2 space-x-8 font-400"
                            onClick={onPrintLabel}
                        >
                            <svg className="fill-actionPrimary w-24 h-24" viewBox="0 0 26 26">
                                <path d="M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z"></path>
                            </svg>
                            <span className="whitespace-nowrap select-none">Print Label</span>
                        </button>
                    )}
                </div>
                <div className="flex flex-col items-center justify-center space-y-32 py-40 px-8">
                    <div className="flex items-center justify-center space-x-64">
                        {todayAppointments && apptIndex > -1 && todayAppointments[apptIndex] ? (
                            <div
                                onClick={() => {
                                    onStartResumeVisit(todayAppointments[apptIndex], cId);
                                }}
                                className="flex flex-col items-center justify-center space-y-16 border border-transparent cursor-pointer rounded-8 w-144 h-144 hover:border-actionPrimary bg-status-infoBG"
                            >
                                <div className="flex items-center justify-center w-64 h-64 rounded-full bg-white">
                                    <div className="flex items-center w-20 h-20 justify-center">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 384 512"
                                            className="fill-actionPrimary w-24 h-24"
                                        >
                                            <path d="M289.94 352l89.37-89.37c6.25-6.25 6.25-16.38 0-22.63L368 228.69c-6.25-6.25-16.38-6.25-22.63 0L256 318.06l-94.24-94.24c52.19-.96 94.24-43.4 94.24-95.82 0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-80h46.06l128 128-89.37 89.37c-6.25 6.25-6.25 16.38 0 22.63L144 475.31c6.25 6.25 16.38 6.25 22.63 0L256 385.94l89.37 89.37c6.25 6.25 16.38 6.25 22.63 0L379.31 464c6.25-6.25 6.25-16.38 0-22.63L289.94 352zM48 176V80h112c26.47 0 48 21.53 48 48s-21.53 48-48 48H48z" />
                                        </svg>
                                    </div>
                                </div>
                                <p className="flex items-center space-x-4 text-actionPrimary font-700 text-14">
                                    {getAppointmentActionTextForAction(
                                        getAppointmentAction(todayAppointments[apptIndex]),
                                    )}
                                </p>
                            </div>
                        ) : (
                            <DoctorSelectorPopup
                                onSelect={(myDoc) => onStartPrescription('', myDoc?.id || '')}
                                clinicId={cId}
                                trigger={'click'}
                            >
                                <StartVisit />
                            </DoctorSelectorPopup>
                        )}
                        {isSingleDoctorAccess() &&
                        (isOnboardedForPharma() || isOnboardedForLab()) ? (
                            <AddAddressBt
                                html={
                                    <div className="flex flex-col items-center justify-center space-y-24 border border-transparent cursor-pointer rounded-8 w-144 h-144 hover:border-actionPrimary bg-status-infoBG">
                                        <div className="flex items-center justify-center w-64 h-64 rounded-full bg-white">
                                            <div className="flex items-center w-20 h-20 justify-center">
                                                <svg
                                                    className="w-24 h-24 fill-actionPrimary"
                                                    viewBox="0 0 9 13"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M5.03906 12.2188C6.25781 10.6953 9 7.0625 9 5C9 2.51562 6.98438 0.5 4.5 0.5C2.01562 0.5 0 2.51562 0 5C0 7.0625 2.74219 10.6953 3.9375 12.2188C4.21875 12.5703 4.75781 12.5703 5.03906 12.2188ZM4.5 6.5C3.65625 6.5 3 5.84375 3 5C3 4.17969 3.65625 3.5 4.5 3.5C5.32031 3.5 6 4.17969 6 5C6 5.84375 5.32031 6.5 4.5 6.5Z" />
                                                </svg>
                                            </div>
                                        </div>
                                        <p className="text-actionPrimary font-700 text-14">
                                            Add Address
                                        </p>
                                    </div>
                                }
                                patient={newPatient}
                            />
                        ) : (
                            <DoctorSelectorPopup
                                onSelect={(myDoc) => onStartPrescription('TELE', myDoc?.id || '')}
                                clinicId={cId}
                                trigger={'click'}
                            >
                                <VideoCallBt />
                            </DoctorSelectorPopup>
                        )}

                        <DoctorSelectorPopup
                            onSelect={(myDoc) => onAddToQueue(myDoc?.id || '')}
                            clinicId={cId}
                            trigger={'click'}
                        >
                            <AddToQueue cId={cId} />
                        </DoctorSelectorPopup>

                        {newPatient && <AdmitPatientAddPtButton patient={newPatient} />}

                        {/* {newPatient?.id && (
                            <div
                                onClick={() => {
                                    setIsAbhaModalVisible(true);
                                }}
                                className="flex flex-col items-center justify-center space-y-16 border border-transparent cursor-pointer rounded-8 w-144 h-144 hover:border-actionPrimary bg-status-infoBG"
                            >
                                <div className="flex items-center justify-center w-64 h-64 rounded-full bg-white">
                                    <div className="flex items-center w-20 h-20 justify-center">
                                        <LinkABHAV2
                                            key={cId + newPatient?.localId}
                                            patient={newPatient}
                                            cId={cId}
                                            isAbhaModalOpen={isAbhaModalVisible}
                                            setIsAbhaModel={(isOpen) => {
                                                setIsAbhaModalVisible(isOpen);
                                            }}
                                            abhaIdCss="text-darwin-neutral-800"
                                            onAbhaLink={() =>
                                                his.replace(
                                                    GO_TO_PATIENTS_DETAILS(
                                                        newPatient?.id || newPatient?.localId,
                                                        'visit',
                                                    ),
                                                )
                                            }
                                        />

                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 384 512"
                                            className="fill-actionPrimary w-24 h-24"
                                        >
                                            <path d="M289.94 352l89.37-89.37c6.25-6.25 6.25-16.38 0-22.63L368 228.69c-6.25-6.25-16.38-6.25-22.63 0L256 318.06l-94.24-94.24c52.19-.96 94.24-43.4 94.24-95.82 0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-80h46.06l128 128-89.37 89.37c-6.25 6.25-6.25 16.38 0 22.63L144 475.31c6.25 6.25 16.38 6.25 22.63 0L256 385.94l89.37 89.37c6.25 6.25 16.38 6.25 22.63 0L379.31 464c6.25-6.25 6.25-16.38 0-22.63L289.94 352zM48 176V80h112c26.47 0 48 21.53 48 48s-21.53 48-48 48H48z" />
                                        </svg>
                                    </div>
                                </div>
                                <p className="text-actionPrimary font-700 text-14">ABHA</p>
                            </div>
                        )} */}
                    </div>
                    <div className="flex items-center p-12 space-x-16">
                        <div
                            className="flex items-center p-12 space-x-8 bg-status-infoBG rounded-8 cursor-pointer border border-transparent hover:border-actionPrimary"
                            onClick={onGoToAllPatients}
                        >
                            <div className="flex items-center justify-center w-40 h-40 bg-white rounded-full">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 640 512"
                                    className="w-20 h-20 fill-actionPrimary"
                                >
                                    <path d="M96 224a64 64 0 1 0-64-64 64.06 64.06 0 0 0 64 64zm224 32a112 112 0 1 0-112-112 111.94 111.94 0 0 0 112 112zm32 96c0-19.1 3.92-37.17 10.09-54.17A152.75 152.75 0 0 1 320 304c-24.6 0-47.6-6-68.5-16h-8.3A115.23 115.23 0 0 0 128 403.2V432a48 48 0 0 0 48 48h241c-39.22-29.19-65-75.47-65-128zm-178.9-77.4A63.81 63.81 0 0 0 128 256H64a64.06 64.06 0 0 0-64 64v32a32 32 0 0 0 32 32h65.9a146.64 146.64 0 0 1 75.2-109.4zM512 224a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm64 144a5.33 5.33 0 0 1-5.33 5.33h-37.34v37.34A5.33 5.33 0 0 1 528 416h-32a5.33 5.33 0 0 1-5.33-5.33v-37.34h-37.34A5.33 5.33 0 0 1 448 368v-32a5.33 5.33 0 0 1 5.33-5.33h37.34v-37.34A5.33 5.33 0 0 1 496 288h32a5.33 5.33 0 0 1 5.33 5.33v37.34h37.34A5.33 5.33 0 0 1 576 336z" />
                                </svg>
                            </div>
                            <p className="text-14 font-700 text-actionPrimary">View All Patients</p>
                        </div>

                        <div
                            className="flex items-center p-12 space-x-8 bg-status-infoBG rounded-8 cursor-pointer border border-transparent hover:border-actionPrimary"
                            onClick={onAddNewPt}
                        >
                            <div className="flex items-center justify-center w-40 h-40 bg-white rounded-full">
                                <svg
                                    viewBox="0 0 20 16"
                                    className="w-20 h-20 fill-actionPrimary"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M19.5 6.5H17.5V4.5C17.5 4.25 17.25 4 17 4H16C15.7188 4 15.5 4.25 15.5 4.5V6.5H13.5C13.2188 6.5 13 6.75 13 7V8C13 8.28125 13.2188 8.5 13.5 8.5H15.5V10.5C15.5 10.7812 15.7188 11 16 11H17C17.25 11 17.5 10.7812 17.5 10.5V8.5H19.5C19.75 8.5 20 8.28125 20 8V7C20 6.75 19.75 6.5 19.5 6.5ZM7 8C9.1875 8 11 6.21875 11 4C11 1.8125 9.1875 0 7 0C4.78125 0 3 1.8125 3 4C3 6.21875 4.78125 8 7 8ZM9.78125 9H9.25C8.5625 9.34375 7.8125 9.5 7 9.5C6.1875 9.5 5.40625 9.34375 4.71875 9H4.1875C1.875 9 0 10.9062 0 13.2188V14.5C0 15.3438 0.65625 16 1.5 16H12.5C13.3125 16 14 15.3438 14 14.5V13.2188C14 10.9062 12.0938 9 9.78125 9Z" />
                                </svg>
                            </div>
                            <p className="text-14 font-700 text-actionPrimary">Add New Patient</p>
                        </div>

                        <BookASlot isLoading={isBookSlotLoading} onSlotBook={onSlotBook} />

                        <DoctorSelectorPopup
                            onSelect={(myDoc) => onSendReceipt(myDoc?.id || '')}
                            clinicId={cId}
                            trigger={'click'}
                        >
                            <SendReceipt />
                        </DoctorSelectorPopup>
                    </div>
                </div>
            </div>
        </div>
    );
};

export type Gender = 'Male' | 'Female' | 'Other';
export const GENDERS: Gender[] = ['Female', 'Male', 'Other'];
export const ONE_CHAR_GENDER: { [k: string]: 'M' | 'F' | 'O' } = {
    male: 'M',
    female: 'F',
    other: 'O',
    others: 'O',
};

export const FULL_GENDER_CHARS: { [k: string]: Gender } = {
    M: 'Male',
    F: 'Female',
    O: 'Other',
};

type State = {
    isActionDialogVisible: boolean;
    isConfigureDialogVisible: boolean;
    newPatient?: Patient;
    iFrameUrl?: string;
    isBookSlotLoading?: boolean;
    todayAppointments?: APWithOptionalpatient[];
    isLoading?: boolean;
    configureTab: ConfigTabs;
    isAbhaOnboarded: string | undefined;
    showAbhaCard?: boolean;
    formState: IFormState | undefined;
    bookAptModal: BookAptModalState;
    selectedDocId?: string;
};

export type NewPatientLocationState = {
    oid?: string;
    name?: string;
    phCode?: string;
    phCodeEnum?: CountryCode;
    phoneNumber?: string;
    visitId?: string;
    visitType?: string;
    age?: {
        age?: string;
        month?: string;
        dob?: {
            dd?: string;
            mm?: string;
            yyyy?: string;
        };
    };
    dob?: string;
    isFieldDisabled?: boolean;
    gender?: Gender;
    defaultShowAbhaCard?: boolean;
    defaultAbhaPtOid?: string;
    defaultAbhaId?: string;
};

interface Props
    extends RouteComponentProps<
        { cId: string },
        StaticContext,
        NewPatientLocationState | undefined
    > {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    isAbdmEnabled: boolean;
    isAbhaNewFlow: boolean;
    isSendAbhaOtp: boolean;
    patient?: Patient;
    mode?: 'actions' | 'add-pt';
    closeMe?: () => void;
}

class NewPatient extends PureComponent<Props, State> {
    state: State = {
        newPatient: this.props.patient,
        isActionDialogVisible: this.props.patient !== undefined,
        isConfigureDialogVisible: false,
        configureTab: 'Patient',
        isAbhaOnboarded: getMyClinics()?.find(
            (c) => c._id === (this.props.match.params.cId ?? getSelectedClinicId()),
        )?.abdm?.hfr_id,
        showAbhaCard: this.props.location?.state?.defaultShowAbhaCard,
        formState:
            this.props.isAbdmEnabled &&
            getMyClinics()?.find(
                (c) => c._id === (this.props.match.params.cId ?? getSelectedClinicId()),
            )?.abdm?.hfr_id
                ? !!this.props.isAbhaNewFlow
                    ? 'abha'
                    : 'add-pt'
                : 'add-pt',
        bookAptModal: {
            show: false,
        },
    };

    onStartPrescription = (visitType: string, docid: string): void => {
        return;
    };

    onStartResumeVisit = (todayAppointment: APWithOptionalpatient, cId: string): void => {
        onAppointmentAction(this, todayAppointment, cId);
    };

    onAddToQueue = async (docid: string): Promise<RequestResponse> => {
        track('Add_To_Queue', { from: 'New_pt' });

        const { newPatient } = this.state;

        if (!newPatient) {
            track('ERROR', { on: 'onAddToQueue', what: 'patient/id not found' });
            return Promise.reject('Something went wrong');
        }

        return WithBEPatient<RequestResponse>(newPatient, (bePt) =>
            bookAppointment({
                docId: docid,
                channel: 'Walkin',
                ptOid: bePt.id,
                cId: this.props.match.params.cId,
                dateTime: new Date().toISOString(),
            }).then((res) => {
                if (res?.success) {
                    his.replace(GO_TO_APPOINTMENTS(this.props.match.params.cId));
                } else {
                    captureErrorString('Failed to add patient: ' + JSON.stringify(res));
                    track('ERROR', { on: 'onAddToQueue', error: JSON.stringify(res) });
                    alert(res?.error?.type || '[1] Failed to add to queue');
                }

                return res;
            }),
        )(this.props.dispatch);
    };

    onPrintLabel = async (): Promise<void> => {
        track('Print_label', { from: 'New_pt' });

        const { newPatient } = this.state;

        if (!newPatient) {
            track('ERROR', { on: 'onPrintLabel', what: 'patient/id not found' });
            return Promise.reject('Something went wrong');
        }

        return WithBEPatient<void>(newPatient, (bePt) => printLabelForPatient(bePt))(
            this.props.dispatch,
        );
    };

    onSendReceipt = (docid: string): void => {
        track('Go_To_Bill_Patient', { from: 'New_pt' });
        const { newPatient } = this.state;

        if (!newPatient) {
            track('ERROR', {
                on: 'onSendReceipt',
                what: 'something terribly wrong',
                error: 'new patient not found',
            });
            return;
        }

        WithBEPatient<Patient>(
            newPatient,
            async (bePt: Patient) => bePt,
        )(this.props.dispatch)
            .then(async (bePt) => {
                const updatedPt = bePt;

                if (updatedPt) {
                    ekaEventDispath({
                        type: 'BILLING_POPUP',
                        data: {
                            docid: docid,
                            uhid:
                                updatedPt.formData
                                    ?.find((fd) => fd.key === 'uhid')
                                    ?.value?.toString() || null,
                            patient: {
                                mobile: updatedPt.personal.phone?.n,
                                uuid: updatedPt.id as string,
                                fln: `${updatedPt.personal.name.f}${
                                    updatedPt.personal.name.l ? updatedPt.personal.name.l : ''
                                }`,
                                oid: updatedPt.id,
                            },
                            clinicId: this.props.match.params.cId,
                            source: 'new-patients',
                        },
                    });
                } else {
                    track('ERROR', { on: 'onSendReceipt', what: 'could not find patient by id' });
                }
            })
            .catch((e) => {
                track('ERROR', { on: 'onSendReceipt', what: 'idk', error: e.message });
                alert('Failed to send receipt + add to queue');
            });
    };

    initalData = {
        name: this.props.location?.state?.name || '',
        phCode: this.props.location?.state?.phCode || '+91',
        phCodeEnum:
            this.props.location?.state?.phCodeEnum ||
            (this.props.location?.state?.phCode && this.props.location?.state?.phoneNumber)
                ? parsePhoneNumber(
                      (
                          this.props.location.state.phCode! + this.props.location.state.phoneNumber!
                      ).trim(),
                  ).country ?? 'IN'
                : 'IN',
        phoneNumber: this.props.location?.state?.phoneNumber,
        dob: this.getDefaultDob(),
        age: this.props.location?.state?.age?.age || '',
        ageMonth: this.props.location?.state?.age?.month || '',
        ageDays: undefined,
        gender: this.props.location?.state?.gender,

        isDobError: false,
        isAgeDOBError: false,
        isNameError: false,
        isGenderError: false,
        isPhoneNumberError: false,
        isActionDialogVisible: false,
        isPhoneInputDisabled:
            this.props.location?.state?.isFieldDisabled !== undefined &&
            this.props.location?.state?.isFieldDisabled === false
                ? false
                : this.props.location?.state?.phoneNumber?.length === 10,
        isNameInputDisabled:
            this.props.location?.state?.isFieldDisabled !== undefined &&
            this.props.location?.state?.isFieldDisabled === false
                ? false
                : this.props.location?.state?.name
                ? this.props.location?.state?.name?.length > 0
                : false,
        isAgeInputDisabled: false,
        isGenderInputDisabled: false,
        dfValues: {},
        isReferralPhoneNumberError: false,
        abhaId: this.props.location?.state?.defaultAbhaId,
        abhaOid: this.props.location?.state?.defaultAbhaPtOid,
    };

    componentDidMount = (): void => {
        const clinics = getDoc()?.profile.professional.clinics;
        if (clinics?.find((c) => c._id === this.props.match.params.cId)) {
        } else {
            this.props.history.replace(GO_TO_ADD_NEW_PATIENT(getSelectedClinicId() || ''));
        }

        // if (
        //     this.state.isAbhaOnboarded &&
        //     !this.state.showAbhaCard &&
        //     this.state.formState === 'add-pt'
        // ) {
        //     renderStuff(
        //         this.props?.isAbdmEnabled,
        //         { ...this.props?.match?.params, link: 'false' },
        //         this.props?.location?.search,
        //     );
        // }

        window.addEventListener(EKA_EVENT, this.onEkaEvents);
        fetchTodayQueue(this.props.match.params.cId)
            .then(async (response: AppointmentsResponse) => {
                if (!response.response?.apt) {
                    return;
                }

                const list = response.response.apt.filter((t) => !isCNRE(t.status));
                const visitIds = list.map((a) => a.aid);
                const localVisits = (await getVisitByIds(visitIds)) || [];
                const localContextList = list.map((a, index) => ({
                    ...a,
                    isLocalPresnt: localVisits[index] !== undefined,
                }));

                this.setState({
                    todayAppointments: localContextList,
                });
            })
            .catch((e) => {
                console.error(e);
                track('ERROR', {
                    on: 'fetchTodayQueue',
                    what: 'fetchTodayQueue error in New Patient',
                    error: (e as Error).message,
                });
            });

        if (this.props.patient) {
            const patient = this.props.patient;
            const newPatient: AddPatientNewPatient = {
                localId: patient.localId,
                oid: patient.id,
                name: [patient.personal.name.f, patient.personal.name.l].filter(Boolean).join(' '),
                phCode: patient.personal.phone?.c,
                phoneNumber: patient.personal.phone?.n,
                age: patient.personal.age,
                gender: patient.personal.gender,
                formData: patient.formData,
                refer_doc_id: patient.refer_doc_id,
                relations: patient.relations,
            };
            this.onSuccess(
                { ...this.props.patient, apiFailure: false },
                newPatient,
                undefined,
                undefined,
            );
        }
    };

    private getDefaultDob() {
        if (this.props.location?.state?.dob) {
            const dob = this.props.location?.state?.dob.split('-');
            if (dob.length === 3) {
                return {
                    dd: dob[2],
                    mm: dob[1],
                    yyyy: dob[0],
                };
            }
        }
        return {
            dd: '0',
            mm: '0',
            yyyy: '0',
        };
    }

    componentWillUnmount(): void {
        // ekaEventDispath({
        //     type: DESTROY_CONTAINER,
        //     containerId: ABHA_IN_DOCTOOL_CONTAINER,
        // });
        window.removeEventListener(EKA_EVENT, this.onEkaEvents);
    }

    componentDidUpdate(
        prevProps: Readonly<Props>,
        prevState: Readonly<State>,
        snapshot?: any,
    ): void {
        // if (prevState.showAbhaCard !== this.state.showAbhaCard) {
        //     if (
        //         this.state.isAbhaOnboarded &&
        //         !this.state.showAbhaCard &&
        //         this.state.formState === 'add-pt'
        //     ) {
        //         renderStuff(
        //             this.props?.isAbdmEnabled,
        //             { ...this.props?.match?.params, link: 'false' },
        //             this.props?.location?.search,
        //         );
        //     }
        // }
    }

    onEkaEvents: EventListener = (e: Event): void => {
        const { detail } = e as CustomEvent<Events>;
        switch (detail.type) {
            case ON_CLOSE_ABHA_CREATION_POPUP:
                this.setState({ isActionDialogVisible: true });
                break;
        }
    };

    onSuccess = (
        patient: Patient & { apiFailure: boolean; error?: any },
        newPatient: AddPatientNewPatient,
        pic?: File,
        doc?: MyDoc,
    ): void => {
        const { dispatch } = this.props;

        this.setState({
            isLoading: false,
        });

        this.onStartPrescription = async (visitType: string, docid: string) => {
            const onSuccess = (prescriptionId: string) => {
                this.props.history.replace(GO_TO_PRESCRIPTION_PAD(prescriptionId, 'edit'));
            };

            const pt = await getPatientByLocalId(patient.localId);

            const initVisitAction = initVisit(
                {
                    ...newPatient,
                    phCode: newPatient.phCode || '+91',
                    localId: patient.localId,
                    id: patient.id,
                    uuid: patient.uuid,
                    abha: Array.isArray(patient.abhaV2)
                        ? patient.abhaV2?.find((abha) => abha.cId === this.props.match.params.cId)
                        : patient?.abha,
                    relations: pt?.relations,
                },
                docid || doc?.id || '',
                this.props.match.params.cId,
                this.props.location?.state?.visitId,
                onSuccess,
                undefined,
                {
                    visitType: this.props.location?.state?.visitType || visitType,
                    autoCopy: true,
                },
            );
            track('Start_Visit', { type: visitType, from: 'New_pt' });
            initVisitAction && dispatch(initVisitAction);
        };
        patient.id && uploadPatientPic(patient.id, pic);
        this.setState({
            isActionDialogVisible: true,
            newPatient: patient,
        });
    };

    onSave = async (
        newP: AddPatientNewPatient,
        pic?: File,
        mh?: MHC,
        doc?: MyDoc,
    ): Promise<void> => {
        if (newP.oid) {
            const pt = await getPatientByLocalId(newP.oid);
            if (pt) {
                this.setState({
                    isLoading: false,
                    newPatient: pt,
                    isActionDialogVisible: true,
                });
                return;
            }
        }
        this.setState({
            isLoading: true,
        });
        const { isAbhaOnboarded } = this.state;

        this.setState({
            selectedDocId: doc?.id,
        });

        if (isAbhaOnboarded && !this.state.showAbhaCard) {
            ekaEventDispath({ type: PATIENT_ABHA_CREATE });
        }

        const newPatient = {
            ...newP,
            localId: this.props.location?.state?.oid || newP.localId || undefined,
            oid: this.props.location?.state?.oid || newP.oid || undefined,
        };

        const settings = await getItemFromMisc<GenieSettings>(
            getMyDbId() || '',
            MISC_KEYS.settings,
        );

        const onSuccess = async (
            patient: Patient & { apiFailure: boolean; error?: any },
            newPatient: AddPatientNewPatient,
            pic?: File,
            doc?: MyDoc,
        ) => {
            if (mh && patient.localId) {
                try {
                    await pushPtMedHistory(
                        doc?.id || getDoc()?._id || '',
                        patient.localId,
                        mh,
                        new Date().toISOString(),
                    );
                } catch (e) {
                    track('ERROR', {
                        on: 'onSave',
                        what: 'pushPtMedHistory error',
                        error: (e as Error).message,
                    });
                    captureErrorString('Failed to push patient medical history: ' + e);
                    notification.error({
                        message: 'Failed to push patient medical history',
                        description: (e as Error)?.message,
                    });
                }
            }
            this.onSuccess(patient, newPatient, pic, doc);
        };

        this.props.dispatch(
            addPatient({
                newPatient,
                sendWelcome: settings.sendWelcome,
                onSuccess: (t) => onSuccess(t, newPatient, pic, doc),
                visitid: this.props.location?.state?.visitId,
                doc,
                onError: (error: string) => {
                    this.setState({
                        isLoading: false,
                        newPatient: undefined,
                        isActionDialogVisible: false,
                    });
                    notification.error({
                        message: 'Failed to add patient',
                        description: error,
                    });
                },
            }),
        );

        return;
    };

    onCancel = (): void => {
        this.props.history.replace('/');
    };

    setConfigureActionDialog = (visible: boolean, tab?: ConfigTabs): void => {
        this.setState({
            isConfigureDialogVisible: visible,
            configureTab: tab ? tab : 'Patient',
        });
    };

    hideIFrameDialog = (): void => {
        this.setState({ iFrameUrl: undefined });
        this.props.history.replace(GO_TO_APPOINTMENTS(this.props.match.params.cId));
    };

    private readonly actions: {
        onCancel: () => void;
        onSave: (newPatient: AddPatientNewPatient, pic?: File) => void;
    } = { onCancel: this.onCancel, onSave: this.onSave };

    setShowAbhaCardHandler = (val: boolean) => this.setState({ showAbhaCard: val });
    setFormState = (val: IFormState | undefined) => this.setState({ formState: val });

    onMultiDocBookApt = (): void => {
        const clinicId = this.props.match.params.cId;

        const { newPatient } = this.state;

        if (!newPatient) {
            track('ERROR', { on: 'onBookApt', what: 'patient/id not found' });
            return;
        }

        WithBEPatient<void>(newPatient, async (bePt) => {
            this.props.history.replace(GO_TO_NEW_APPOINTMENT(clinicId));
            setTimeout(() => {
                ekaEventDispath({
                    type: ADD_NEW_PT_APPT,
                    data: bePt,
                });
            }, 700);

            return;
        })(this.props.dispatch);
    };

    onCloseBookAptModal = (): void => {
        this.setState({ bookAptModal: { show: false } });
    };

    handleAppointmentBooking = (apt: Appointment): void => {
        const isSameDay = moment(apt.full_date).isSame(moment(), 'day');
        this.props.history.replace(
            GO_TO_APPOINTMENTS(
                this.props.match.params.cId,
                isSameDay ? 'today-queue' : 'upcoming',
                undefined,
                `date=${moment(apt.full_date).format('YYYY-MM-DD')}&left=booked`,
            ),
        );
    };

    render(): ReactNode {
        const { mode, closeMe } = this.props;
        const {
            newPatient,
            isActionDialogVisible,
            iFrameUrl,
            isBookSlotLoading,
            isConfigureDialogVisible,
            todayAppointments,
            isLoading,
            configureTab,
            showAbhaCard,
            formState,
            selectedDocId,
        } = this.state;

        const isAbhaOnboarded = getMyClinics()?.find(
            (c) => c._id === (this.props.match.params.cId ?? getSelectedClinicId()),
        )?.abdm?.hfr_id;

        return (
            <div className="flex flex-col w-full h-full bg-white font-lato select-none">
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>EKA - New Patient</title>
                </Helmet>

                {mode !== 'actions' && (
                    <div className="grid grid-cols-prescriptionPadGrid h-full min-w-840 overflow-x-auto">
                        <LeftBar />
                        <StaticLeftPanel />

                        <PatientInfoComp
                            data={this.initalData}
                            ActionBar={ActionBar}
                            FillerComp={FillerComp}
                            actions={this.actions}
                            isDialogVisible={isConfigureDialogVisible}
                            setDialogVisibility={this.setConfigureActionDialog}
                            showAddFields={true}
                            showUseABDM={!!isAbhaOnboarded}
                            isLoading={isLoading}
                            configureTab={configureTab}
                            isAbdmEnabled={this.props.isAbdmEnabled}
                            abhaNewFlow={this.props.isAbhaNewFlow}
                            showAbhaCard={showAbhaCard}
                            setShowAbhaCardHandler={this.setShowAbhaCardHandler}
                            formState={formState}
                            setFormState={(val: IFormState | undefined) =>
                                this.setState({ formState: val })
                            }
                            isSendAbhaOtp={this.props.isSendAbhaOtp}
                        />
                    </div>
                )}

                <AnimatePresence>
                    {isActionDialogVisible && newPatient && (
                        <ActionDialog
                            pName={[newPatient.personal.name.f, newPatient.personal.name.l]
                                .filter(Boolean)
                                .join(' ')}
                            onStartPrescription={this.onStartPrescription}
                            onSlotBook={this.onMultiDocBookApt}
                            cId={this.props.match.params.cId}
                            onAddToQueue={this.onAddToQueue}
                            onSendReceipt={this.onSendReceipt}
                            isBookSlotLoading={isBookSlotLoading}
                            onPrintLabel={this.onPrintLabel}
                            newPatient={newPatient}
                            todayAppointments={todayAppointments}
                            onStartResumeVisit={this.onStartResumeVisit}
                            selectedDocId={selectedDocId}
                            closeMe={closeMe}
                        />
                    )}

                    {iFrameUrl && (
                        <IFrameBareDialog
                            id={CURIO_IFRAME_ID}
                            url={iFrameUrl}
                            closeMe={this.hideIFrameDialog}
                        />
                    )}
                </AnimatePresence>
                <SlotModal
                    show={this.state.bookAptModal.show}
                    clinicId={this.state.bookAptModal.clinicId}
                    docId={this.state.bookAptModal.docId}
                    ptId={this.state.bookAptModal.ptId}
                    onClose={this.onCloseBookAptModal}
                    handleAppointmentBooking={this.handleAppointmentBooking}
                />
            </div>
        );
    }
}

const FillerComp: React.FC<{
    Form: ReactNode;
    ActionBar: ReactNode;
    onDyFormUpdate: () => void;
    isDialogVisible: boolean;
    setDialogVisibility: (visible: boolean) => void;
    updateShowMedicalHistory?: (val: boolean) => void;
    configureTab?: ConfigTabs;
    formState?: IFormState;
    onRefresh: () => void;
}> = ({
    Form,
    ActionBar,
    onDyFormUpdate,
    setDialogVisibility,
    isDialogVisible,
    updateShowMedicalHistory,
    configureTab,
    formState,
    onRefresh,
}) => {
    return (
        <div className="flex flex-col col-span-10 overflow-hidden bg-white pad-selected-shadow">
            {formState === 'add-pt' && (
                <div className="flex items-center justify-between bg-white px-16 py-8">
                    <p className="text-neutral-black font-700">Add New Patient</p>
                    <div className="flex space-x-16">
                        {/* <ToggleAbhaFlowVersion showText={true} showBorder={true} /> */}
                        <ConfigureDyForms
                            onDyFormUpdate={onDyFormUpdate}
                            isDialogVisible={isDialogVisible}
                            setDialogVisibility={setDialogVisibility}
                            updateShowMedicalHistory={updateShowMedicalHistory}
                            configureTab={configureTab}
                            onRefresh={onRefresh}
                        />
                    </div>
                </div>
            )}
            <div className="flex flex-col h-full overflow-hidden bg-neutral-9">
                <div
                    className={`flex flex-col ${
                        formState === 'add-pt' ? 'px-24 pt-8' : 'p-16'
                    } flex-1 overflow-hidden space-y-16`}
                >
                    <div
                        className={`flex flex-col flex-1 ${
                            formState === 'add-pt' ? 'p-16' : 'p-0'
                        } overflow-auto bg-white rounded-t-8`}
                    >
                        {Form}
                    </div>
                </div>

                <div className="w-full border-b border-neutral-7"></div>
                {ActionBar}
            </div>
        </div>
    );
};

const ActionBar: React.FC<{
    onCancel: () => void;
    onSave: (doc?: MyDoc) => void;
    isDisabled?: boolean;
    isAbdmEnabled?: boolean;
    showAbhaCard?: boolean;
    setAddPtFormState?: (val: IFormState | undefined) => void;
    setShowAbhaCardHandler?: (val: boolean) => void;
}> = ({
    onCancel,
    onSave,
    isDisabled,
    isAbdmEnabled,
    showAbhaCard,
    setAddPtFormState,
    setShowAbhaCardHandler,
}) => {
    return (
        <div className="flex justify-between p-16 bg-white">
            <div className="flex items-center space-x-16">
                <button onClick={onCancel} className="neutral-btn px-12 py-8 btn--small">
                    <span className="w-full text-center">Cancel</span>
                </button>
            </div>

            <div className="space-x-16">
                {/* {isAbdmEnabled && !showAbhaCard && (
                    <button
                        className="rounded-4 px-12 bg-white border border-actionPrimary py-8 font-700 text-actionPrimary"
                        onClick={() => {
                            track('UNDO_SKIP_ABHA');
                            setShowAbhaCardHandler && setShowAbhaCardHandler(true);
                            setAddPtFormState && setAddPtFormState('abha');
                        }}
                        style={{
                            borderRadius: '0.5rem',
                        }}
                    >
                        Create ABHA
                    </button>
                )} */}
                <DoctorSelectorPopup onSelect={onSave}>
                    <button className="primary-btn px-12 py-8 btn--small" disabled={isDisabled}>
                        <span className="w-full text-center"> Add Patient</span>
                    </button>
                </DoctorSelectorPopup>
            </div>
        </div>
    );
};

const StaticLeftPanel = () => {
    return (
        <div className="grid h-full grid-flow-row overflow-hidden bg-white grid-rows-leftpanel leftpanel">
            <div className="flex flex-col justify-center p-16 space-y-16 border-b border-r border-light">
                <div className="mx-8 h-18 bg-actionPrimary bg-opacity-10"></div>
                <div className="mx-8 h-18 bg-actionPrimary bg-opacity-10"></div>
            </div>
            <div className="flex flex-col overflow-auto">
                <div className="menuitem selected">
                    <div>
                        <div className="flex items-center justify-center w-16 h-16">
                            <svg width="16" height="16" viewBox="0 0 448 512">
                                <path d="M433.94 65.94l-51.88-51.88A48 48 0 0 0 348.12 0H176a48 48 0 0 0-48 48v48H48a48 48 0 0 0-48 48v320a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48v-48h80a48 48 0 0 0 48-48V99.88a48 48 0 0 0-14.06-33.94zM352 32.49a15.88 15.88 0 0 1 7.43 4.2l51.88 51.88a16 16 0 0 1 4.2 7.43H352zM288 464a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V144a16 16 0 0 1 16-16h80v240a48 48 0 0 0 48 48h112zm128-96a16 16 0 0 1-16 16H176a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h144v72a24.07 24.07 0 0 0 24 24h72zM314.67 182.67A6.67 6.67 0 0 0 308 176h-40a6.67 6.67 0 0 0-6.67 6.67v46.66h-46.66A6.67 6.67 0 0 0 208 236v40a6.67 6.67 0 0 0 6.67 6.67h46.66v46.66A6.67 6.67 0 0 0 268 336h40a6.67 6.67 0 0 0 6.67-6.67v-46.66h46.66A6.67 6.67 0 0 0 368 276v-40a6.67 6.67 0 0 0-6.67-6.67h-46.66z"></path>
                            </svg>
                        </div>
                        <p>Add Patient Info</p>
                    </div>
                    <div>
                        <svg
                            width="25"
                            height="25"
                            viewBox="0 0 28 28"
                            className="fill-neutral-5 cursor-pointer"
                            preserveAspectRatio="xMidYMid meet"
                        >
                            <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                        </svg>
                    </div>
                </div>
                <div className="flex-auto border-r border-light"></div>
            </div>
        </div>
    );
};

export default connect((state: GlobalState) => ({
    isAbdmEnabled: getGenieSetting(state, 'abdm') as boolean,
    isAbhaNewFlow: false,
    isSendAbhaOtp: getGenieSetting(state, 'isSendAbhaOtp') as boolean,
}))(NewPatient);

export { NewPatient };

const VideoCallBt: React.FC<{ onStartPrescription?: () => void; children?: ReactNode }> = ({
    onStartPrescription,
}) => {
    return (
        <div
            onClick={onStartPrescription}
            className="flex flex-col items-center justify-center space-y-24 border border-transparent cursor-pointer rounded-8 w-144 h-144 hover:border-actionPrimary bg-status-infoBG"
        >
            <div className="flex items-center justify-center w-64 h-64 rounded-full bg-white">
                <div className="flex items-center w-20 h-20 justify-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                        className="w-24 h-24 fill-actionPrimary"
                    >
                        <path d="M543.9 96c-6.2 0-12.5 1.8-18.2 5.7L416 170.1v-58.3c0-26.4-23.2-47.8-51.8-47.8H51.8C23.2 64 0 85.4 0 111.8v288.4C0 426.6 23.2 448 51.8 448h312.4c28.6 0 51.8-21.4 51.8-47.8v-58.3l109.7 68.3c5.7 4 12.1 5.7 18.2 5.7 16.6 0 32.1-13 32.1-31.5V127.5C576 109 560.5 96 543.9 96zM368 200v198.9c-.6.4-1.8 1.1-3.8 1.1H51.8c-2 0-3.2-.6-3.8-1.1V113.1c.6-.4 1.8-1.1 3.8-1.1h312.4c2 0 3.2.6 3.8 1.1V200zm160 155.2l-112-69.8v-58.7l112-69.8v198.3z" />
                    </svg>
                </div>
            </div>
            <p className="text-actionPrimary font-700 text-14">Start Video Call</p>
        </div>
    );
};

const StartVisit: React.FC<{
    onStartPrescription?: () => void;
}> = ({ onStartPrescription }) => {
    return (
        <div
            onClick={onStartPrescription}
            className="flex flex-col items-center justify-center space-y-16 border border-transparent cursor-pointer rounded-8 w-144 h-144 hover:border-actionPrimary bg-status-infoBG"
        >
            <div className="flex items-center justify-center w-64 h-64 rounded-full bg-white">
                <div className="flex items-center w-20 h-20 justify-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 384 512"
                        className="fill-actionPrimary w-24 h-24"
                    >
                        <path d="M289.94 352l89.37-89.37c6.25-6.25 6.25-16.38 0-22.63L368 228.69c-6.25-6.25-16.38-6.25-22.63 0L256 318.06l-94.24-94.24c52.19-.96 94.24-43.4 94.24-95.82 0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-80h46.06l128 128-89.37 89.37c-6.25 6.25-6.25 16.38 0 22.63L144 475.31c6.25 6.25 16.38 6.25 22.63 0L256 385.94l89.37 89.37c6.25 6.25 16.38 6.25 22.63 0L379.31 464c6.25-6.25 6.25-16.38 0-22.63L289.94 352zM48 176V80h112c26.47 0 48 21.53 48 48s-21.53 48-48 48H48z" />
                    </svg>
                </div>
            </div>
            <p className="text-actionPrimary font-700 text-14">Start Visit</p>
        </div>
    );
};
